import ReturnMessage from "../shared/ReturnMessage";
import SelectInput from "../ui/SelectInput";
import Button from "../ui/Button";
import LoadingOverlay from "../shared/LoadingOverlay";
import usePost from "../../hooks/usePost";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ModalFormWrapper from "../shared/ModalFormWrapper";
import tick from "../../assets/icons/tick-big.svg";
import { closeReasonList, dealSourceList, kycHeatList } from "../../data/portalFormListData";
import chevronDown from "../../assets/icons/chevron-down-big-white.svg";

const PortalClosedLostModal = ({ closeModal, closedBy, dealId, initialKycHeat }) => {
    // State
    const [validateForm, setValidateForm] = useState(false);
    const [reason, setReason] = useState("");
    const [dealSrc, setDealSrc] = useState("");
    const [kycHeat, setKycHeat] = useState(initialKycHeat || "");

    const [validateReset, setValidateReset] = useState(false);
    const [resetSuccess, setResetSuccess] = useState(false);

    // Hooks
    const { sending: loading, returnMessage, postData } = usePost();
    const { sending, returnData: resetData, returnMessage: resetClosedMessage, postData: postClosed } = usePost();
    const navigate = useNavigate();

    // Use effect
    useEffect(() => {
        if (resetData) {
            closeModal();
        }
    }, [closeModal, reason, navigate, postData, resetSuccess, validateReset, dealId, resetData]);

    // Submit
    const submitHandler = (e) => {
        e.preventDefault();
        setValidateForm(true);

        // Form complete
        if (reason && reason.length > 1) {
            setValidateReset(true);
            setResetSuccess(false);
            // Set data
            let formData = {
                reason: reason,
                closedBy: closedBy,
                dealId: dealId,
                dealSource: dealSrc,
                kycHeat: kycHeat,
            };

            // Post
            postClosed(formData, "/api/portal/closeDeal", 1000);
        }
    };

    return (
        <ModalFormWrapper title="Set Closed/Lost Reason">
            <ReturnMessage returnMessage={resetClosedMessage} />

            {loading || sending ? (
                <LoadingOverlay />
            ) : returnMessage.error ? (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__success">
                            <div className="login-form__body__title">Could not close the deal</div>
                            <br />
                            <br />
                            <div className="login-form__body__submit-container">
                                <Link to="/">
                                    <Button onClick={closeModal} disabled={sending} classNames={["button--full"]}>
                                        Return
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ) : resetSuccess ? (
                <div className="login-form">
                    <div className="login-form__success">
                        <img className="login-form__success__tick" src={tick} alt="" />
                        <div className="login-form__success__message">The deal has been closed successfully</div>
                        <Button onClick={closeModal}>Return</Button>
                    </div>
                </div>
            ) : (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__body__title">You are setting this deal to Closed/Lost</div>
                        <div className="login-form__body__intro">Please provide a reason</div>

                        <form onSubmit={submitHandler}>
                            <SelectInput
                                value={(value) => setReason(value)}
                                options={closeReasonList}
                                label="Why is the deal being closed?*"
                                required
                                chevron={chevronDown}
                                validateForm={validateForm}
                                classNames={["select-input--full select-input--form"]}
                            />

                            <SelectInput
                                value={(value) => setKycHeat(value)}
                                options={kycHeatList}
                                label="KYC Heat*"
                                required
                                chevron={chevronDown}
                                validateForm={validateForm}
                                classNames={["select-input--full select-input--form"]}
                                defaultValue={initialKycHeat}
                            />

                            <SelectInput
                                value={(value) => setDealSrc(value)}
                                options={dealSourceList}
                                label="Deal source*"
                                required
                                chevron={chevronDown}
                                validateForm={validateForm}
                                classNames={["select-input--full select-input--form"]}
                            />

                            <div className="login-form__body__submit-container">
                                <Button disabled={sending} classNames={["button--full"]}>
                                    Save
                                </Button>
                            </div>
                        </form>

                        {sending && <LoadingOverlay />}
                    </div>
                </div>
            )}
        </ModalFormWrapper>
    );
};

export default PortalClosedLostModal;
